import { Nullable } from '@/utils/types';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';

export const getTotalCarParks = (covered: Nullable<number | string>, uncovered: Nullable<number | string>): number => {
  const arr = [covered, uncovered];

  return arr.reduce((acc: number, item) => {
    if (isValuePresent(item)) {
      acc += parseInt(item as string);
    }

    return acc;
  }, 0);
}
